import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

function ProtectedRoute({ session, ready }) {
  const location = useLocation();

  if (!ready) {
    return (
      <div className="grid min-h-screen place-items-center bg-surface text-sm font-semibold text-primary">
        Checking your SilaTrail session…
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  return <Outlet context={session} />;
}

export default ProtectedRoute;
